import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import ReactDOM from 'react-dom';
import { Modal, Nav, NavItem, UncontrolledCollapse, ModalBody, ModalHeader } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { withRouter, Redirect } from 'react-router-dom';
import { AxiosAPI, getGroupID, getUserID } from '../../helpers/AxiosAPI';
import { gAPI_Internal_Property_By_Id, putAPI_Update_Domains } from '../../constants/APIs';
import IntlMessages from '../../helpers/IntlMessages';

import {
  setContainerClassnames,
  addContainerClassname,
  changeDefaultClassnames,
  changeSelectedMenuHasSubItems,
  changeDomains,
  ChangeGroupId,
  ChangeUserRole,
  CheckVoucherEngine,
} from '../../redux/actions';

import menuItems from '../../constants/menu';
import dialogLogins from '../../data/dialogLogins';

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedParentMenu: '',
      viewingParentMenu: '',
      domains: [],
      isAvailable: false,
      showModal: false
    };
  }

  handleWindowResize = (event) => {
    if (event && !event.isTrusted) {
      return;
    }
    const { containerClassnames } = this.props;
    let nextClasses = this.getMenuClassesForResize(containerClassnames);
    this.props.setContainerClassnames(
      0,
      nextClasses.join(' '),
      this.props.selectedMenuHasSubItems
    );
  };

  handleDocumentClick = (e) => {
    const container = this.getContainer();
    if (container != null) {
      let isMenuClick = false;
      if (
        e.target &&
        e.target.classList &&
        (e.target.classList.contains('menu-button') ||
          e.target.classList.contains('menu-button-mobile'))
      ) {
        isMenuClick = true;
      } else if (
        e.target.parentElement &&
        e.target.parentElement.classList &&
        (e.target.parentElement.classList.contains('menu-button') ||
          e.target.parentElement.classList.contains('menu-button-mobile'))
      ) {
        isMenuClick = true;
      } else if (
        e.target.parentElement &&
        e.target.parentElement.parentElement &&
        e.target.parentElement.parentElement.classList &&
        (e.target.parentElement.parentElement.classList.contains('menu-button') ||
          e.target.parentElement.parentElement.classList.contains(
            'menu-button-mobile'
          ))
      ) {
        isMenuClick = true;
      }
      if (container.contains(e.target) || container === e.target || isMenuClick) {
        return;
      }
      this.setState({
        viewingParentMenu: '',
      });
      this.toggle();
    }
  };

  getMenuClassesForResize = (classes) => {
    const { menuHiddenBreakpoint, subHiddenBreakpoint } = this.props;
    let nextClasses = classes.split(' ').filter((x) => x !== '');
    const windowWidth = window.innerWidth;
    if (windowWidth < menuHiddenBreakpoint) {
      nextClasses.push('menu-mobile');
    } else if (windowWidth < subHiddenBreakpoint) {
      nextClasses = nextClasses.filter((x) => x !== 'menu-mobile');
      if (
        nextClasses.includes('menu-default') &&
        !nextClasses.includes('menu-sub-hidden')
      ) {
        nextClasses.push('menu-sub-hidden');
      }
    } else {
      nextClasses = nextClasses.filter((x) => x !== 'menu-mobile');
      if (
        nextClasses.includes('menu-default') &&
        nextClasses.includes('menu-sub-hidden')
      ) {
        nextClasses = nextClasses.filter((x) => x !== 'menu-sub-hidden');
      }
    }
    return nextClasses;
  };

  getContainer = () => {
    return ReactDOM.findDOMNode(this);
  };

  toggle = () => {
    const hasSubItems = this.getIsHasSubItem();
    this.props.changeSelectedMenuHasSubItems(hasSubItems);
    const { containerClassnames, menuClickCount } = this.props;
    const currentClasses = containerClassnames
      ? containerClassnames.split(' ').filter((x) => x !== '')
      : '';
    let clickIndex = -1;

    if (!hasSubItems) {
      if (
        currentClasses.includes('menu-default') &&
        (menuClickCount % 4 === 0 || menuClickCount % 4 === 3)
      ) {
        clickIndex = 1;
      } else if (
        currentClasses.includes('menu-sub-hidden') &&
        (menuClickCount === 2 || menuClickCount === 3)
      ) {
        clickIndex = 0;
      } else if (
        currentClasses.includes('menu-hidden') ||
        currentClasses.includes('menu-mobile')
      ) {
        clickIndex = 0;
      }
    } else {
      if (currentClasses.includes('menu-sub-hidden') && menuClickCount === 3) {
        clickIndex = 2;
      } else if (
        currentClasses.includes('menu-hidden') ||
        currentClasses.includes('menu-mobile')
      ) {
        clickIndex = 0;
      }
    }
    if (clickIndex >= 0) {
      this.props.setContainerClassnames(
        clickIndex,
        containerClassnames,
        hasSubItems
      );
    }
  };

  handleProps = () => {
    this.addEvents();
  };

  addEvents = () => {
    ['click', 'touchstart', 'touchend'].forEach((event) =>
      document.addEventListener(event, this.handleDocumentClick, true)
    );
  };

  removeEvents = () => {
    ['click', 'touchstart', 'touchend'].forEach((event) =>
      document.removeEventListener(event, this.handleDocumentClick, true)
    );
  };

  setSelectedLiActive = (callback) => {
    const oldli = document.querySelector('.sub-menu  li.active');
    if (oldli != null) {
      oldli.classList.remove('active');
    }

    /* set selected parent menu */
    const selectedlink = document.querySelector('.sub-menu  a.active');
    if (selectedlink != null) {
      selectedlink.parentElement.classList.add('active');
      this.setState(
        {
          selectedParentMenu:
            selectedlink.parentElement.parentElement.getAttribute(
              'data-parent'
            ),
        },
        callback
      );
    } else {
      var selectedParentNoSubItem = document.querySelector(
        '.main-menu  li a.active'
      );
      if (selectedParentNoSubItem != null) {
        this.setState(
          {
            selectedParentMenu:
              selectedParentNoSubItem.getAttribute('data-flag'),
          },
          callback
        );
      } else if (this.state.selectedParentMenu === '') {
        if (menuItems[0].to === window.location.pathname) {
          this.setState(
            {
              selectedParentMenu: menuItems[0].id,
            },
            callback
          );
        }else if (menuItems.filter((f)=>f.to=== window.location.pathname).length > 0){
          this.setState(
            {
              selectedParentMenu: menuItems.filter((f)=>f.to=== window.location.pathname)[0].id,
            },
            callback
          );
        }
      }    
    }
  };

  setHasSubItemStatus = () => {
    const hasSubmenu = this.getIsHasSubItem();
    this.props.changeSelectedMenuHasSubItems(hasSubmenu);
    this.toggle();
  };

  getIsHasSubItem = () => {
    const { selectedParentMenu } = this.state;
    const menuItem = menuItems.find((x) => x.id === selectedParentMenu);
    if (menuItem)
      return menuItem && menuItem.subs && menuItem.subs.length > 0
        ? true
        : false;
    else return false;
  };

  checkMenuAccess = (menudomains, type) => {
    if (type !== undefined) {
      const userId = getUserID();
      const login = dialogLogins.filter(
        (m) =>
          m.label === type && m.logins.filter((l) => l === userId).length > 0
      );
      if (login.length > 0) {
        return true;
      } else {
        return false;
      }
    }
    if (menudomains !== undefined) {
      // if(this.state.isAvailable)
      let hasAccess = false;

      this.state.domains.forEach((p) => {
        menudomains.forEach((r) => {
          if (this.state.isAvailable) {            
            if (p.type === r) {
              hasAccess = true;
            }
          } else {            
            if (p.type === r) {
              hasAccess = true;
            }
          }
        });
      });
      return hasAccess;
    } else return true;
  };

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.setSelectedLiActive(this.setHasSubItemStatus);
      // Hide the menu after click
      let nextClasses = ['menu-sub-hidden'];
      this.props.setContainerClassnames(
        0,
        nextClasses.join(' '),
        this.props.selectedMenuHasSubItems
      );
      window.scrollTo(0, 0);
    }
    this.handleProps();
  }

  componentDidMount() {
    if (this.props.pid === '-1') {
      const allgroups = [{ type: 'AllGroups', priority: 1 }];
      this.setState({ domains: allgroups });
      this.props.CheckVoucherEngine(false);
      this.props.changeDomains(allgroups);
    } else {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Internal_Property_By_Id}/${this.props.pid
          }?group_id=${getGroupID()}`,
      })
        .then((res) => {
          let val = 0;
          res.data.domains.map((d) => {
            if (d.type === 'VoucherEngine') {
              val = 1;
            }
          });
          if (val === 1) {
            this.setState({ isAvailable: true });
            this.props.CheckVoucherEngine(true);
            this.props.ChangeGroupId(getGroupID());
          } else {

            this.props.ChangeGroupId(getGroupID());
            // console.log(res.data.domains);
            let lst= res.data.domains;          
            lst.push({ type: 'VoucherEngine', priority: 1 });    
            let data={domains:lst,updater:'Admin'}        
            AxiosAPI({
              method: 'put',
              url: `${putAPI_Update_Domains}/${this.props.pid}`,
              data,
            }).then(() =>
              setTimeout(() => {
                //window.location.reload();
              }, 300)
            );
          }
          this.props.CheckVoucherEngine(true);
          this.setState({ domains: res.data.domains });
          this.props.changeDomains(res.data.industryDomains);
        })
        .catch((err) => console.error(err));
    }
    window.addEventListener('resize', this.handleWindowResize);
    this.handleWindowResize();
    this.handleProps();
    this.setSelectedLiActive(this.setHasSubItemStatus);       
    const selectedParent = menuItems.filter(f => f.to === window.location.pathname);
    if (selectedParent.length === 0) {
      this.props.changeSelectedMenuHasSubItems(false);      
        this.setState({
          viewingParentMenu: '',
          selectedParentMenu: '',
        });
        this.toggle();      
    }
  }

  componentWillUnmount() {
    this.removeEvents();
    window.removeEventListener('resize', this.handleWindowResize);
  }

  openSubMenu = (e, menuItem) => {    
    const selectedParent = menuItem.id;
    const hasSubMenu = menuItem.subs && menuItem.subs.length > 0;
    this.props.changeSelectedMenuHasSubItems(hasSubMenu);
    if (!hasSubMenu) {
      this.setState({
        viewingParentMenu: selectedParent,
        selectedParentMenu: selectedParent,
      });
      this.toggle();
    } else {
      e.preventDefault();

      const { containerClassnames, menuClickCount } = this.props;
      const currentClasses = containerClassnames
        ? containerClassnames.split(' ').filter((x) => x !== '')
        : '';

      if (!currentClasses.includes('menu-mobile')) {
        if (
          currentClasses.includes('menu-sub-hidden') &&
          (menuClickCount === 2 || menuClickCount === 0)
        ) {
          this.props.setContainerClassnames(3, containerClassnames, hasSubMenu);
        } else if (
          currentClasses.includes('menu-hidden') &&
          (menuClickCount === 1 || menuClickCount === 3)
        ) {
          this.props.setContainerClassnames(2, containerClassnames, hasSubMenu);
        } else if (
          currentClasses.includes('menu-default') &&
          !currentClasses.includes('menu-sub-hidden') &&
          (menuClickCount === 1 || menuClickCount === 3)
        ) {
          this.props.setContainerClassnames(0, containerClassnames, hasSubMenu);
        }
      } else {
        this.props.addContainerClassname(
          'sub-show-temporary',
          containerClassnames
        );
      }
      this.setState({
        viewingParentMenu: selectedParent,
      });
    }
  };

  render() {
    var restUrl = window.location.href.substring(
      window.location.href.length,
      window.location.href.lastIndexOf('/') + 1
    );
    const match = this.props.match;
    const { selectedParentMenu, viewingParentMenu, domains } = this.state;
    //console.log('selectedParentMenu', selectedParentMenu);
    //console.log('viewingParentMenu', viewingParentMenu);
    const { role } = this.props;
    this.props.ChangeUserRole(role);
    return (
      <Fragment>
        {this.props.role === 'View' ? null :
          <div className="sidebar">
            <div className="main-menu">
              <div className="scroll">
                <PerfectScrollbar
                  option={{ suppressScrollX: true, wheelPropagation: false }}
                >
                  <Nav vertical className="list-unstyled">              
                    {menuItems &&
                      menuItems.map((item) => {
                        if (
                          (role === 'Admin' ||
                            (role === 'User' && item.label !== 'menu.admin')) &&
                          this.checkMenuAccess(item.domains, item.type) === true
                        )
                          return (
                            <NavItem
                              key={item.id}
                              className={classnames({
                                active:
                                  (selectedParentMenu === item.id &&
                                    viewingParentMenu === '') ||
                                  viewingParentMenu === item.id,
                              })}
                            >
                              {item.newWindow ? (
                                <a
                                  href={item.to}
                                  rel="noopener noreferrer"
                                  target="_blank"
                                >
                                  <i className={item.icon} />{' '}
                                  <IntlMessages id={item.label} />
                                </a>
                              ) : (
                                <NavLink
                                  to={item.to}
                                  onClick={(e) => this.openSubMenu(e, item)}
                                  data-flag={item.id}
                                >
                                  <i className={item.icon} />{' '}
                                  <IntlMessages id={item.label} />
                                </NavLink>
                              )}
                            </NavItem>
                          );
                      })}
                  </Nav>
                </PerfectScrollbar>
                <div className="sidebar-menu-whatsnew">
                  <a
                    rel="noopener noreferrer"
                    onClick={()=>this.setState({showModal:true})}
                  >What's New
                  </a>
                </div>
              </div>
            </div>     
            
            <div className="sub-menu">
              <div className="scroll">
                <PerfectScrollbar
                  option={{ suppressScrollX: true, wheelPropagation: false }}
                >  
                  {menuItems &&
                    menuItems.map((item) => {
                      return (
                        <Nav
                          key={item.id}
                          className={classnames({
                            'd-block':
                              (this.state.selectedParentMenu === item.id &&
                                this.state.viewingParentMenu === '') ||
                              this.state.viewingParentMenu === item.id,
                          })}
                          data-parent={item.id}
                        >
                          {item.subs &&
                          item.subs.map((sub, index) => {
                              if (
                                this.checkMenuAccess(sub.domains, sub.type) === true
                              )
                                return (
                                  <NavItem key={`${item.id}_${index}`}>
                                    {sub.newWindow ? (
                                      <a
                                        href={sub.to}
                                        rel="noopener noreferrer"
                                        target="_blank"
                                      >
                                        <i className={sub.icon} />{' '}
                                        <IntlMessages id={sub.label} />
                                      </a>
                                    ) : sub.subs && sub.subs.length > 0 ? (
                                      <Fragment>
                                        <NavLink
                                          to={sub.to}
                                          id={`${item.id}_${index}`}
                                        >
                                          <i className={sub.icon} />{' '}
                                          <IntlMessages id={sub.label} />
                                        </NavLink>

                                        <UncontrolledCollapse
                                          toggler={`#${item.id}_${index}`}
                                        >
                                          <Nav className="third-level-menu">
                                            {sub.subs.map(
                                              (thirdSub, thirdIndex) => {
                                                return (
                                                  <NavItem
                                                    key={`${item.id}_${index}_${thirdIndex}`}
                                                  >
                                                    {thirdSub.newWindow ? (
                                                      <a
                                                        href={thirdSub.to}
                                                        rel="noopener noreferrer"
                                                        target="_blank"
                                                      >
                                                        <i
                                                          className={thirdSub.icon}
                                                        />{' '}
                                                        <IntlMessages
                                                          id={thirdSub.label}
                                                        />
                                                      </a>
                                                    ) : (
                                                      <NavLink to={thirdSub.to}>
                                                        <i
                                                          className={thirdSub.icon}
                                                        />{' '}
                                                        <IntlMessages
                                                          id={thirdSub.label}
                                                        />
                                                      </NavLink>
                                                    )}
                                                  </NavItem>
                                                );
                                              }
                                            )}
                                          </Nav>
                                        </UncontrolledCollapse>
                                      </Fragment>
                                    ) : (
                                      <NavLink to={sub.to}>
                                        <i className={sub.icon} />{' '}
                                        <IntlMessages id={sub.label} />
                                      </NavLink>
                                    )}
                                  </NavItem>
                                );
                            })}
                        </Nav>
                      );
                    })}                  
                </PerfectScrollbar>
              </div>
            </div>
            <Modal
              isOpen={this.state.showModal}
              toggle={()=>this.setState({showModal:false})}
              size="lg"
              style={{ maxWidth: '1024px' }}
            >
              <ModalHeader toggle={()=>this.setState({showModal:false})}></ModalHeader>
              <ModalBody>
                <iframe
                  src="https://pages.bookmebob.com/aiva-feature-updates"
                  width="950"
                  height="700"
                  frameBorder="0"
                />
              </ModalBody>
            </Modal>
          </div>
        }
      </Fragment>

    );
  }
}

const mapStateToProps = ({ menu, settings }) => {
  const {
    containerClassnames,
    subHiddenBreakpoint,
    menuHiddenBreakpoint,
    menuClickCount,
    selectedMenuHasSubItems,
  } = menu;
  const { locale, propertyId, userRole } = settings;
  return {
    containerClassnames,
    subHiddenBreakpoint,
    menuHiddenBreakpoint,
    menuClickCount,
    selectedMenuHasSubItems,
    locale,
    propertyId,
  };
};
export default withRouter(
  connect(mapStateToProps, {
    setContainerClassnames,
    addContainerClassname,
    changeDefaultClassnames,
    changeSelectedMenuHasSubItems,
    changeDomains,
    CheckVoucherEngine,
    ChangeUserRole,
    ChangeGroupId,
  })(Sidebar)
);
